/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Edit_HintInputs */

const en_gc_home_edit_hint = /** @type {(inputs: Gc_Home_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try changing a value. The total follows.`)
};

const zh_gc_home_edit_hint = /** @type {(inputs: Gc_Home_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试着修改数字，合计会实时更新。`)
};

/**
* | output |
* | --- |
* | "Try changing a value. The total follows." |
*
* @param {Gc_Home_Edit_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_edit_hint = /** @type {((inputs?: Gc_Home_Edit_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Edit_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_edit_hint(inputs)
	return zh_gc_home_edit_hint(inputs)
});
export { gc_home_edit_hint as "gc.home.edit_hint" }